import { RouteComponentProps } from 'react-router'
import HeaderComponent from '../component/header/HeaderComponent';
import BlockValidationSummaryComponent from '../component/block/BlockValidationSummaryComponent'
import BlockValidationPlatformSummaryComponent from '../component/block/BlockValidationPlatformSummaryComponent';
import { EModule } from '../../domain/User/Emodule';
import storage from '../util/storage';
import BlockPreValidationSummaryComponent from '../component/block/BlockPreValidationSummaryComponent';

interface Params {
  dossierId: string
}

const DashboardDossier = ({ match }: RouteComponentProps<Params>): JSX.Element => {
  const dossierId = match?.params?.dossierId
  const userProfile = storage.getUserInformation()

  return (
    <>
      <HeaderComponent />
      {userProfile?.modules?.includes(EModule.PlatformValidator)
        ?
        <BlockValidationPlatformSummaryComponent dossierId={dossierId} />
        : (userProfile?.modules?.includes(EModule.PreSignatureValidator) ?
          <>
          <BlockPreValidationSummaryComponent dossierId={dossierId} />
          </>
        :
        <BlockValidationSummaryComponent dossierId={dossierId} />
        )
      }
    </>
  )
}

export default DashboardDossier;